import { PdfReplacement } from './ReceiptPdf.types';
import { NON_BREAKING_SPACE, NON_READABLE_IEN, READABLE_IEN } from '../../common/constants';

export const receiptPriceReplacements: PdfReplacement[] = [
  {
    replaceable: NON_BREAKING_SPACE,
    replacement: ' '
  },
  {
    replaceable: NON_READABLE_IEN,
    replacement: READABLE_IEN
  }
];

export const MAX_LINES_FOR_ONE_PAGE = 7;
